import React from 'react'
import Slider from '../component/slider/Slider';
import VideoItems from '../component/video/VideoItems';

const Home = () => {
  return <div>
    <Slider />
    <VideoItems />
  </div>
}

export default Home
